import { AnyObject } from "../interfaces/AnyObject";
import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const baseRoutingOrdersRoute = `${baseUrl}/routings-api`;
export const baseAccountsRoute = `${baseUrl}/accounts-api`;

export const getRousingOrderSearchRoute = (searchParams: AnyObject) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing-orders/search`,
    searchParams,
  });

export const getRousingOrderVersionsRoute = (routingOrderId) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing-orders/${routingOrderId}/versions`,
  });

export const getRousingOrderUpdateStatusRoute = () =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing-orders/`,
  });

export const getRousingOrderDeleteStatusRoute = (searchParams) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing-orders/`,
    searchParams,
  });

export const getRousingOrderAgreements = (searchParams) =>
  buildUrl({
    url: `${baseAccountsRoute}/agreements/search`,
    searchParams,
  });
